module.exports = __webpack_public_path__ + "static/img/gpsReports.da1305c1.svg";